import { StepLabels } from '@shared/claim/steps';
export function stepDisplayName(step) {
    var _a;
    return step ? (_a = StepLabels[step]) !== null && _a !== void 0 ? _a : `${step}` : null;
}
